<ion-header>
  <ion-toolbar>
    <ion-title>Your Conversations</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" [strong]="true">Close<ion-icon name="close"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div *ngIf="(getConversationsMetadata() | async) as conversations">
    <div *ngFor="let conversation of conversations">
      <ion-card (click)="openSendMessageModal(conversation)" color="medium">
        <ion-card-title>{{determineRecipient(conversation)}}
          <ion-icon *ngIf="hasUnreadMessages(conversation)" name="mail-unread-outline"></ion-icon>
          <ion-icon *ngIf="!hasUnreadMessages(conversation)" name="mail-open-outline"></ion-icon>
        </ion-card-title>
      </ion-card>
    </div>
  </div>
</ion-content>